var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/require-array-sort-compare */
import { PHONE, CPO_KEY, ALL_PHONES_KEY, ALL_TABLETS_KEY } from '../../../constants';
function formatDeviceData(deviceType, devices) {
    var _a;
    var regularCategoryKeys = new Set(); // eg. "ios", "android"
    var regularCategoryNames = new Set(); // eg. "IOS", "Android"
    var count = {};
    var ALL_CATEGORIES_KEY = getAllCategoriesKey(deviceType);
    // names we want to define the order of in the display buttons, eg. "All Categories", "Certified Pre-owned"
    var specialCategoryNames = (_a = {},
        _a[ALL_CATEGORIES_KEY] = '',
        _a[CPO_KEY] = '',
        _a);
    var newDevices = devices.map(function (device) {
        var _a, _b;
        var categories = [];
        (_b = (_a = device === null || device === void 0 ? void 0 : device.koodoParameters) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.forEach(function (cat) {
            count[cat.key] = (count[cat.key] || 0) + 1;
            // in newDevices, each device now has a simple category array with the keys
            categories.push(cat.key);
            // sets the name based on key to account for French
            if (cat.key === ALL_CATEGORIES_KEY || cat.key === CPO_KEY) {
                specialCategoryNames[cat.key] = cat.name;
                return;
            }
            // adds the category to the set if it's not CPO or All Categories
            regularCategoryKeys.add(cat.key);
            regularCategoryNames.add(cat.name);
        });
        return __assign(__assign({}, device), { categories: categories });
    });
    // inner categories are sorted alphabetically
    var sortedCategoryKeys = __spreadArray([ALL_CATEGORIES_KEY], Array.from(regularCategoryKeys).sort(), true);
    var sortedCategoryNames = __spreadArray([
        specialCategoryNames[ALL_CATEGORIES_KEY]
    ], Array.from(regularCategoryNames).sort(), true);
    // do not show CPO unless there are some available
    if (count[CPO_KEY] > 0) {
        sortedCategoryKeys.push(CPO_KEY);
        sortedCategoryNames.push(specialCategoryNames[CPO_KEY]);
    }
    var deviceCount = sortedCategoryKeys.map(function (key) { return count[key] || 0; });
    return {
        deviceCount: deviceCount,
        machineNameCategories: sortedCategoryKeys,
        uniqueCategoryNames: sortedCategoryNames,
        newDevices: newDevices
    };
}
export function getAllCategoriesKey(deviceType) {
    return deviceType === PHONE ? ALL_PHONES_KEY : ALL_TABLETS_KEY;
}
export default formatDeviceData;
